import * as z from "zod/v4";

export const runUnifiedBillingMigration = {
  name: "runUnifiedBillingMigration" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ success: z.boolean(), workflowId: z.string() }),
};
